<bn-loading-overlay></bn-loading-overlay>
<div class="container mt-3 mx-auto">
  <div class="row">
    <div class="col">
      <h5>Subscrição de cotas (cadastro)</h5>
    </div>
    <div class="col-auto">
      <button
        type="button"
        class="btn btn-danger"
        bnConfirm
        tituloConfirm="Confirmação"
        msgConfirm="Descartar novo cadastro de Subscrição de Cotas?"
        (onConfirm)="cancelarCadastro()">
        Cancelar
      </button>

      <button type="button" class="btn btn-primary" (click)="salvar()" *ngIf="temSubscricoesNovas()"
          >Salvar
      </button>
    </div>
  </div>
  <div class="row">
    <div class="bn-form-group col-md-8">
      <app-select-cotista (selecionado)="selecionaCotista($event)"></app-select-cotista>
    </div>
    <div class="bn-form-group col-md-2" *ngIf="cotistaSelecionado != null">
      <label class="form-label" for="cnpj-cotista">CNPJ</label>
      <input id="cnpj-costista" class="form-control" readonly [value]="cotistaSelecionado?.cnpj | bnCnpj" >
    </div>
    <div class="bn-form-group col-md-2" style="display: flex; align-items: center; margin-top: 1.5em;" >
      <label-conglomerado-dica [cotistaSelecionado]="cotistaSelecionado"></label-conglomerado-dica>
    </div>
  </div>
  <form [formGroup]="subscricaoForm">
  <div class="row">
      <div class="bn-form-group col-md-4" *ngIf="cotistaSelecionado != null">
        <label class="form-label" for="valor-aporte">Valor do aporte R$</label>
        <input id="valor-aporte" class="form-control moeda" bnMask="MOEDA" formControlName="valor">
      </div>
      <div class="bn-form-group col-md-3" *ngIf="cotistaSelecionado != null">
        <label class="form-label" for="data-subscricao">Data da subscrição</label>
        <bn-datepicker
            name="data-subscricao"
            formControlName="data"
            idInput="data-subscricao"
            ngDefaultControl
            [maxDate]="dataHoje">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-2" *ngIf="cotistaSelecionado != null">
        <label class="form-label" for="categoria">Categoria</label>
        <select id="categoria" class="form-select" formControlName="categoria">
          <option></option>
          <option *ngFor="let categoria of categorias">{{ categoria }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-2" *ngIf="cotistaSelecionado != null"
        style="display: flex;justify-content: flex-end;align-items: flex-start;flex-direction: column; flex-basis: max-content;">
        <button type="button" class="btn btn-primary no-margin" (click)="incluirSubscricao()">Incluir subscrição</button>
      </div>
    </div>
  </form>
  <div class="table-responsive" *ngIf="cotistaSelecionado">
    <table class="table">
      <thead>
        <th>Aporte</th>
        <th>Valor do aporte R$</th>
        <th>Data da subscrição</th>
        <th>Categoria</th>
        <th>Ações</th>
      </thead>
      <tbody>
        <tr *ngIf="subscricoes.length === 0">
          <td colspan="5" style="font-style: italic;">
            Nenhuma subscrição adicionada.
          </td>
        </tr>
        <tr *ngFor="let item of subscricoes; let indexItem = index">
          <td>{{ item.numeroAporte | numeroAporte }}</td>
          <td>{{ item.valor | currency:'BRL' }}</td> 
          <td>{{ item.data | date:'dd/MM/yyyy' }}</td>
          <td>{{ item.categoria }}</td>
          <td id=col-acoes>
            <a
              href="javascript:void(0)"
              *ngIf="item.id === null"
              bnConfirm tituloConfirm="Confirmação" msgConfirm="Descartar novo cadastro de Subscrição de Cotas?"
				      (onConfirm)="remover(indexItem)">
              <i class="fa fa-trash cursor-pointer margin-left-5" placement="left-top" ngbTooltip="Excluir Subscrição"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
